import React from 'react';
import { Visualization } from '../../../../nebula/components/visualization/Visualization';
import type { VisualizationData } from '../../../../nebula/types';

interface MessageVisualizationsProps {
  visualizations: VisualizationData[];
}

const MessageVisualizations: React.FC<MessageVisualizationsProps> = ({ visualizations }) => {
  if (visualizations.length === 0) return null;

  return (
    <div className="mt-4 space-y-4">
      {visualizations.map((visualization, index) => (
        <div
          key={`${visualization.config.type}-${visualization.config.title}-${index}`}
          className="rounded-lg border border-gray-200 bg-white p-4"
        >
          <Visualization data={visualization} animated={false} />
        </div>
      ))}
    </div>
  );
};

export default MessageVisualizations;
